import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import Logo from "../../components/Logo";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const res = await register(name, email, password);
        setLoading(false);
        if (!res.ok) {
            setError(res.error);
            return;
        }
        navigate("/dashboard", { replace: true });
    };

    return (
        <div className="min-h-screen flex flex-col lg:flex-row" data-testid="register-page">
            <aside className="lg:w-1/2 relative overflow-hidden border-b lg:border-b-0 lg:border-r border-avx-line p-10 lg:p-16 flex flex-col justify-between min-h-[260px]">
                <div className="absolute inset-0 opacity-30">
                    <img src="https://images.unsplash.com/photo-1762281429507-a0384348f4b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="" className="w-full h-full object-cover" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-avx-bg/80 to-avx-bg" />
                <div className="relative">
                    <Logo />
                </div>
                <div className="relative max-w-md">
                    <div className="label-mono mb-3">/ Create your account</div>
                    <h2 className="font-heading font-black text-3xl lg:text-4xl tracking-tighter leading-tight">
                        Join the <span className="text-avx-blue">AVX Pro</span> ecosystem.
                    </h2>
                </div>
            </aside>
            <main className="lg:w-1/2 flex items-center justify-center p-8 lg:p-16">
                <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
                    <div className="label-mono mb-2">/ New account</div>
                    <h1 className="font-heading font-black text-3xl tracking-tighter mb-2">Create account</h1>
                    <p className="text-sm text-avx-muted mb-8">Your AVX Pro customer account will be created instantly.</p>

                    {error && (
                        <div className="mb-4 p-3 border border-avx-danger/40 bg-avx-danger/10 text-avx-danger text-sm rounded-sm" data-testid="register-error">
                            {error}
                        </div>
                    )}

                    <div className="space-y-4 mb-6">
                        <div>
                            <Label className="label-mono">Name</Label>
                            <Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name-input"
                                className="mt-2 bg-avx-surface border-avx-line h-11 focus:border-avx-blue focus:ring-1 focus:ring-avx-blue" />
                        </div>
                        <div>
                            <Label className="label-mono">Email</Label>
                            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email-input"
                                className="mt-2 bg-avx-surface border-avx-line h-11 focus:border-avx-blue focus:ring-1 focus:ring-avx-blue" />
                        </div>
                        <div>
                            <Label className="label-mono">Password</Label>
                            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password-input"
                                className="mt-2 bg-avx-surface border-avx-line h-11 focus:border-avx-blue focus:ring-1 focus:ring-avx-blue" />
                        </div>
                    </div>

                    <button type="submit" disabled={loading} data-testid="register-submit-btn"
                        className="btn-primary w-full py-3 text-xs font-mono uppercase tracking-[0.2em] rounded-sm">
                        {loading ? "Creating…" : "Create account"}
                    </button>

                    <div className="mt-6 text-xs">
                        <Link to="/login" className="text-avx-muted hover:text-avx-blue font-mono uppercase tracking-[0.18em]" data-testid="register-login-link">
                            Already have an account? Log in →
                        </Link>
                    </div>
                </form>
            </main>
        </div>
    );
}
